import { cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (theme: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {
        card: {
            gap: theme.spacing(1.5),
        },
        header: {
            [`>.${cardHeaderClasses.content}`]: {
                [`.${typographyClasses.root}`]: {
                    fontSize: "1.5rem",
                },
            },
        },
    },
    variants: [
        {
            props: { widgetVariant: "dashboard" },
            style: {
                [`.${simpleWidgetCardClasses.card}`]: {
                    backgroundImage: "url(/styles/default/images/widget-bg-vouchers-s.png)",
                    [`.${simpleWidgetCardClasses.content}`]: {
                        padding: 0,
                    },
                    [`.${simpleWidgetCardClasses.actions}`]: {
                        padding: 0,
                    },
                },
                [`.${simpleWidgetCardClasses.cover}`]: {
                    backgroundImage: "url(/styles/default/images/widget-bg-vouchers-s.png)",
                },
            },
        },
        {
            props: { widgetVariant: "startpage" },
            style: {
                padding: 0,
                [`.${simpleWidgetCardClasses.card}`]: {
                    border: 0,
                    boxShadow: "none",
                },
                [`.${simpleWidgetCardClasses.content}`]: {
                    padding: 0,
                },
                [`.${simpleWidgetCardClasses.actions}`]: {
                    padding: 0,
                },
            },
        },
    ],
})
